import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ParaProvider"] */ "/vercel/path0/app/providers/para-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/providers/query-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolanaProvider"] */ "/vercel/path0/app/providers/solana-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShellWrapper"] */ "/vercel/path0/components/layout/shell-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileDebugPanel"] */ "/vercel/path0/components/mobile-debug-panel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SDKProviders"] */ "/vercel/path0/components/providers/lifi-sdk-solana-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BodyScrollReset"] */ "/vercel/path0/components/util/body-scroll-reset.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@getpara/react-sdk/dist/css/modal.css");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/node_modules/sonner/dist/index.mjs");
